import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" There are no records to show. ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icons_currency = _resolveComponent("icons-currency")
  const _component_Column = _resolveComponent("Column")
  const _component_single_price = _resolveComponent("single-price")
  const _component_CurrenciesChart = _resolveComponent("CurrenciesChart")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_ctx.pricesStatus === 'success' && _ctx.statusAssets === 'success' && _ctx.status === 'success')
    ? (_openBlock(), _createBlock(_component_DataTable, {
        key: this.initialLocalCurrency,
        loading: _ctx.pricesStatus === 'fetching' || _ctx.statusAssets === 'fetching' && _ctx.status === 'fetching',
        class: " table-striped p-datatable-sm animated fadeIn",
        autoLayout: true,
        paginator: true,
        rows: 10,
        paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
        rowsPerPageOptions: [10, 20, 50],
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
        value: _ctx.updatePrices()
      }, {
        empty: _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: "Name",
            headerClass: "text-center",
            bodyClass: "text-center"
          }, {
            body: _withCtx(({data}) => [
              _createVNode("span", null, [
                _createVNode(_component_icons_currency, {
                  cryptoCurrency: data.currencyId,
                  width: '20',
                  height: '20'
                }, null, 8, ["cryptoCurrency"]),
                _hoisted_2,
                _createVNode("b", null, _toDisplayString(data.currencyId), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Amount",
            headerClass: "text-right",
            bodyClass: "text-right"
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(_ctx.formatZeros(data.balance, data.currency.exact)) + " " + _toDisplayString(data.currencyId), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Price",
            headerClass: "text-right",
            bodyClass: "text-right"
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_single_price, {
                parity: { local: _ctx.initialLocalCurrency, cripto: data.currencyId },
                type: "higher",
                side: "spot",
                balance: 1
              }, null, 8, ["parity"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Total Value",
            headerClass: "text-right",
            bodyClass: "text-right"
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_single_price, {
                parity: { local: _ctx.initialLocalCurrency, cripto: data.currencyId },
                type: "higher",
                side: "spot",
                balance: data.balance
              }, null, 8, ["parity", "balance"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Performance 1W",
            headerClass: "text-right",
            style: !_ctx.$isAdmin ? '' : 'display: none;',
            class: { 'd-lg-inline-block': !_ctx.$isAdmin }
          }, {
            body: _withCtx(({data}) => [
              (!_ctx.$isAdmin)
                ? (_openBlock(), _createBlock(_component_CurrenciesChart, {
                    key: 0,
                    localCurrency: _ctx.initialLocalCurrency.toLowerCase(),
                    criptoCurrency: _ctx.getCryptoName(data.currencyId)
                  }, null, 8, ["localCurrency", "criptoCurrency"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["style", "class"])
        ]),
        _: 1
      }, 8, ["loading", "value"]))
    : _createCommentVNode("", true)
}